const TOOL_STATUS_LABELS: Record<string, string> = {
  KnowledgeBaseDocumentSearchTool: 'Searching the knowledge base…',
  KnowledgeBaseGetDocumentTool: 'Reading the full document…',
  WebSearchTool: 'Searching the web…'
};

export const getToolStatusLabel = (toolName: string): string => TOOL_STATUS_LABELS[toolName] ?? `Running ${toolName}…`;

export const DRAFTING_STATUS = 'Drafting answer…';
export const THINKING_STATUS = 'Thinking…';
